import appEnv from 'bundles/enterprise-learning-path-description-page/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
